var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverInsuranceNotupdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ic_driver_insurance_notupdated",
    "data-name": "Ic_driver insurance_notupdated",
    transform: "translate(-1544 -454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-document-1319226",
    transform: "translate(1544 454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M196.44,56V74.263h8.118v-4.28a.457.457,0,0,1,.457-.457h3.945V56Zm1.5,1.848h9.138a.457.457,0,1,1,0,.913h-9.1a.457.457,0,1,1-.043-.913Zm0,2.454h9.138a.457.457,0,1,1,0,.913h-9.1a.457.457,0,1,1-.043-.913Zm0,2.454h9.138a.457.457,0,1,1,0,.913h-9.1a.457.457,0,0,1-.043-.913Zm0,2.454h9.138a.457.457,0,1,1,0,.913h-9.1a.457.457,0,0,1-.043-.913Zm-.043,2.461h5.258a.457.457,0,1,1,0,.913h-5.172a.459.459,0,0,1-.086-.913Z",
    transform: "translate(-196.44 -56)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M417.99,410.18h3.267l-3.267,3.51Z",
    transform: "translate(-408.959 -395.742)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(-1938 183)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3489 283)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x1: 3,
    y2: 3,
    transform: "translate(3492.5 286.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverInsuranceNotupdated);
export default __webpack_public_path__ + "static/media/driver_insurance_notupdated.956c564fe38382384fdef6c70d85d0bc.svg";
export { ForwardRef as ReactComponent };